import { render } from "./FullNameInput.vue?vue&type=template&id=221e6023&scoped=true"
import script from "./FullNameInput.vue?vue&type=script&lang=js"
export * from "./FullNameInput.vue?vue&type=script&lang=js"

import "./FullNameInput.vue?vue&type=style&index=0&id=221e6023&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221e6023"]])

export default __exports__